import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { TermsDialog } from '@sorare/core/src/components/conversionCredit/TermsDialog/index.tsx';
import { glossary } from '@sorare/core/src/lib/glossary';

const TermsLink = styled.button`
  color: var(--c-nd-600);
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;
  font: var(--t-label-s);
`;

export const InviteTermsApplyLink = () => {
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <>
      <Horizontal center>
        <TermsLink type="button" onClick={() => setTermsOpen(true)}>
          <FormattedMessage {...glossary.termsApply} />
        </TermsLink>
      </Horizontal>
      <TermsDialog
        open={termsOpen}
        terms="setReferralTerms"
        onClose={() => setTermsOpen(false)}
      />
    </>
  );
};
